import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "How long does a typical installation take?",
    a: "Most residential systems are installed within 2–3 days after site survey and approval. Larger commercial projects are scheduled in phases.",
  },
  {
    q: "Will I still need CEB electricity?",
    a: "Yes, unless you choose a fully off-grid system with battery backup. Most clients stay connected to the grid for reliability and net-metering benefits.",
  },
  {
    q: "What warranty do you offer?",
    a: "Solar panels carry a 25-year output warranty, inverters 5–10 years, and batteries up to 10 years. Our workmanship warranty is 2 years.",
  },
  {
    q: "Do you handle CEB paperwork?",
    a: "Yes — we manage the full CEB SSDG / MSDG application process on your behalf.",
  },
  {
    q: "Do you offer maintenance contracts?",
    a: "Yes. We offer scheduled cleaning, performance checks and priority response service plans.",
  },
];

export function FAQ() {
  return (
    <section id="faq" className="py-24 sm:py-32">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <span className="text-sm font-medium text-primary uppercase tracking-widest">FAQ</span>
          <h2 className="mt-3 text-4xl sm:text-5xl font-bold tracking-tight">
            Questions, answered.
          </h2>
        </div>

        <Accordion type="single" collapsible className="mt-12">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-border">
              <AccordionTrigger className="text-left text-base sm:text-lg font-medium hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
